export const formatPhoneNumber = (input: string): string => {
  const digits = input.replace(/\D/g, '');

  if (digits.length === 10) {
    return `+1${digits}`;
  } else if (digits.length === 11 && digits.startsWith('1')) {
    return `+${digits}`;
  } else if (digits.startsWith('00')) {
    return `+${digits.slice(2)}`;
  } else if (digits.startsWith('+')) {
    return digits;
  }

  return `+${digits}`;
};